import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setPostUpdatePercent = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_PERCENT_UPDATE_REFERRALS
            });
            dispatch(Action.SetGetReferrals({
                page: 1,
                rowsPerPage: 10,
            }))
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostUpdatePercent as SetPostUpdatePercent
}